import { useAmp } from 'next/amp'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import { FC, useEffect, useState } from 'react'

import { LINK_URL_ROOT, LINK_URL_LOGIN } from '../../utillities/LinkURL'
import LinkWrapper from '../Link'
import { useTranslation } from '../../hooks/useTranslation'
import LOGO_EN from './assets/logo_employer_en.svg'
import LOGO_VN from './assets/logo_employer_vn.svg'
import useCurrentEmployer from '../../hooks/useCurrentEmployer'
const SideBarContent = dynamic(() => import('./SideBarContent'))

const SideBarEmployer: FC<{ scrollToContactFormProps? }> = ({ scrollToContactFormProps }) => {
  const isAmp = useAmp()
  const [showSidebar, setShowSidebar] = useState(false)
  const [currentUser] = useCurrentEmployer()
  const { translate, currentLanguage } = useTranslation()
  const [showBg, setShowBg] = useState(false)
  const isLogIn = !!currentUser

  const toggleSideBar = () => {
    setShowSidebar(!showSidebar)
  }

  useEffect(() => {
    function updateScrollPosition() {
      const isTop = window.scrollY !== 0
      if (isTop !== showBg) setShowBg(isTop)
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', updateScrollPosition, false)
      return function cleanup() {
        window.removeEventListener('scroll', updateScrollPosition, false)
      }
    }
  }, [showBg])

  return (
    <div className={`sidebar none-shadow ${showBg ? 'header-bg' : ''}`}>
      <button type="button" aria-label="nav-icon" id="nav-icon" className={`${showSidebar ? 'open' : ''}`} onClick={toggleSideBar}>
        <div className="wrap-icon">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      <div className="logo">
        <LinkWrapper prefetch={false} href={LINK_URL_ROOT}>
          <a className="header-logo-img">
            <div className="logo-freec">
              {currentLanguage === 'en' ? (
                isAmp === true ? (
                  <div style={{ width: 80, height: 32, margin: 'auto' }}>
                    <amp-img width={80} height={32} src={LOGO_EN?.src} alt="freec-platform" layout="responsive" />
                  </div>
                ) : (
                  <Image src={LOGO_EN} alt="freec-platform" width={80} height={32} />
                )
              ) : isAmp === true ? (
                <div style={{ width: 150, height: 34, margin: 'auto' }}>
                  <amp-img width={150} height={34} src={LOGO_VN?.src} alt="freec-platform" layout="responsive" />
                </div>
              ) : (
                <Image src={LOGO_VN} alt="freec-platform" width={150} height={34} />
              )}
            </div>
          </a>
        </LinkWrapper>
        {/* {!isLogIn && (
          <LinkWrapper prefetch={false} href={LINK_URL_LOGIN} as={LINK_URL_LOGIN}>
            <a>
              <button type="button" className="btn-link">
                {translate('header:login_register')}
              </button>
            </a>
          </LinkWrapper>
        )} */}
      </div>
      {showSidebar && <SideBarContent scrollToContactFormProps={scrollToContactFormProps} toggleSideBar={toggleSideBar} />}
    </div>
  )
}

export default SideBarEmployer
